// extracted by mini-css-extract-plugin
export var apiV2Setup = "api-v2-setup_R1eO1lYdL8k79E4sVX2m";
export var apiV2SetupKeyControl = "api-v2-setup__key-control_OovKhLKwjs35fiVMovQo";
export var apiV2SetupKeyControlShield = "api-v2-setup__key-control-shield_yucschL0BYjnznlf4Q6h";
export var apiV2SetupKeyControlShieldActive = "api-v2-setup__key-control-shield_active_IB9mgaZcrN6LiTs5KKUQ";
export var customGroupField = "custom-group__field_kZKSuHMxIgAmZOf8fvmt";
export var customGroupLabel = "custom-group__label_hBGHFb2_zH_OsHr5rkdq";